import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";

const CopyTrading = () => {
  const location = useLocation();
  const outletRef = useRef(null);
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState();

  useEffect(() => {
    if (outletRef.current) {
      outletRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [location]);

  const services = [
    { label: "Futures", route: "Futures" },
    { label: "Spot", route: "Spot" },
    
  ];

  const handleCardClick = (e, route) => {
    e.preventDefault();
    setSelectedCard(route);
    navigate(`/copy-trading/${route}`);
  };

  return (
    <>

      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />

        <div className="max-w-7xl mx-auto my-16">
          <div className="flex space-x-3 font-medium text-lg mb-6">
           
            {services.map((service, index) => (
              <div
                key={index}
                onClick={(e) => handleCardClick(e, service.route)}
                className={`cursor-pointer text-center border-b-2 ${
                  selectedCard === service.route
                    ? "border-b-2 border-yellow-500"
                    : ""
                }`}
              >
                <div className="text-xs md:text-lg font-medium md:px-4 px-2">
                  {service.label}
                </div>
              </div>
            ))}
          </div>

          <div ref={outletRef}>
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default CopyTrading;
